import {
  getCountryBusiness
} from '../api/apiFun'
let leftMenu = [{
    menuname: '',
    menus: [{
      icon: require('../assets/icon/dashboard.png'),
      icon_s: require('../assets/icon/dashboard_s.png'),
      menuname: 'Dashboard',
    }]
  },
  {
    menuname: '',
    menus: [{
      icon: require('../assets/icon/sms_list.png'),
      icon_s: require('../assets/icon/sms_list_s.png'),
      menuname: 'SMS',
    }]
  },
  {
    menuname: 'CONFIGURATION',
    menus: [{
        icon: require('../assets/icon/sim_card.png'),
        icon_s: require('../assets/icon/sim_card_s.png'),
        menuname: 'SIM Card',
      },
      {
        icon: require('../assets/icon/card_holder.png'),
        icon_s: require('../assets/icon/card_holder_s.png'),
        menuname: 'Card Holder',
      },
      {
        icon: require('../assets/icon/operators.png'),
        icon_s: require('../assets/icon/operators_s.png'),
        menuname: 'Operator',
      },
      {
        icon: require('../assets/icon/super_agent.png'),
        icon_s: require('../assets/icon/super_agent_s.png'),
        menuname: 'Super Agent',
      },
      {
        icon: require('../assets/icon/business.png'),
        icon_s: require('../assets/icon/business_s.png'),
        menuname: 'Business',
      },
      {
        icon: require('../assets/icon/settlement.png'),
        icon_s: require('../assets/icon/settlement_s.png'),
        menuname: 'Business settlement',
      },
      {
        icon: require('../assets/icon/country.png'),
        icon_s: require('../assets/icon/country_s.png'),
        menuname: 'Country',
      },
    ]
  },
  {
    menuname: 'ORDERS',
    menus: [{
        icon: require('../assets/icon/transactions.png'),
        icon_s: require('../assets/icon/transactions_s.png'),
        menuname: 'Transactions',
      },
      {
        icon: require('../assets/icon/transfers.png'),
        icon_s: require('../assets/icon/transfers_s.png'),
        menuname: 'Transfers',
      }
    ]
  },
  {
    menuname: 'APP',
    menus: [{
        icon: require('../assets/icon/app_users.png'),
        icon_s: require('../assets/icon/app_users_s.png'),
        menuname: 'APP Users',
      },
      {
        icon: require('../assets/icon/automatic.png'),
        icon_s: require('../assets/icon/automatic_s.png'),
        menuname: 'Automatic',
      }
    ]
  },
  {
    menuname: '',
    menus: [{
      icon: require('../assets/icon/setting.png'),
      icon_s: require('../assets/icon/setting_s.png'),
      menuname: 'Setting',
    }]
  },
];


/**
 * 时间戳
 * @param {*} timestamp  时间戳
 */
const timestampToTime = (timestamp) => {
  if (timestamp) {
    let time = new Date(timestamp * 1000)
    let year = time.getFullYear()
    const month = (time.getMonth() + 1).toString().padStart(2, '0')
    const date = (time.getDate()).toString().padStart(2, '0')
    const hours = (time.getHours()).toString().padStart(2, '0')
    const minute = (time.getMinutes()).toString().padStart(2, '0')
    const second = (time.getSeconds()).toString().padStart(2, '0')
    return year + '-' + month + '-' + date + ' ' + hours + ':' + minute + ':' + second
  } else {
    return ''
  }
};
const timestampToDate = (timestamp) => {
  if (timestamp) {
    let time = new Date(timestamp * 1000)
    let year = time.getFullYear()
    const month = (time.getMonth() + 1).toString().padStart(2, '0')
    const date = (time.getDate()).toString().padStart(2, '0')
    return year + '-' + month + '-' + date
  } else {
    return ''
  }
};
const currentDate = () => {
  var date = new Date();
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  month = (month > 9) ? month : ("0" + month);
  day = (day < 10) ? ("0" + day) : day;
  return year + "-" + month + "-" + day;
};
/**
 * 设置cookie
 **/
function setCookie(name, value, hours) {
  var exp = new Date();
  exp.setTime(exp.getTime() + hours * 3600000);
  document.cookie = name + "=" + value + ";expires=" + exp.toGMTString();
};

/**
 * 获取cookie
 **/
function getCookie(name) {
  let reg = RegExp(name + '=([^;]+)');
  let arr = document.cookie.match(reg);
  if (arr) {
    return arr[1];
  } else {
    return '';
  }
};

/**
 * 删除cookie
 **/
function delCookie(name) {
  setCookie(name, null, -1);
};

function uploadUrl() {
  return '/admin/file_upload';
}

function parseParams(data) {
  try {
    var tempArr = [];
    for (var i in data) {
      var key = encodeURIComponent(i);
      var value = encodeURIComponent(data[i]);
      tempArr.push(key + '=' + value);
    }
    var urlParamsStr = tempArr.join('&');
    return urlParamsStr;
  } catch (err) {
    return '';
  }
}

function exportUrl(url, params) {
  return url + "?authorization=" + getCookie('dkh_token') + "&" + parseParams(params);
}

function getSocket(callback) {
  let socket;
  if (typeof (WebSocket) === 'undefined') {
    console.log('Your browser does not support WebSocket');
  } else {
    console.log('Your browser supports WebSocket');
    // 初始化 WebSocket 对象，指定要连接的服务器地址与端口建立连接
    socket = new WebSocket("wss://mango-maxshopping.com/wss?uid=9999");
    // 打开事件
    socket.onopen = function () {
      console.log('Socket opened');
    };
    // 获得消息事件
    socket.onmessage = function (msg) {
      // 发现消息进入, 开始处理前端触发逻辑
      callback(msg, socket);
      var data = JSON.parse(msg.data)
      if (data.type == 'success_send') {
        alert('success_send')
      }
      if (data.type == 'faild_send') {
        alert('faild_send')
      }
      if (data.type == 'socket_close') {
        alert(`${data.close_user} offline`)
      }
      console.log(data)
    };
    // close事件
    socket.onclose = function () {
      console.log('Socket closed');
    };
    // 发生了错误事件
    socket.onerror = function () {
      console.log('Socket error occurred, please refresh the page');
      // 此时可以尝试刷新页面
    };
  }
}

function cascaderChange(value) {
  var country_id = ''
  var business_id = ''
  if (value.length > 0) {
    if (value.length > 1) {
      business_id = value[1]
    } else {
      country_id = value[0]
    }
  }
  return [country_id, business_id];
}
/**
 * 导出 
 **/
export {
  leftMenu,
  timestampToTime,
  timestampToDate,
  currentDate,
  setCookie,
  getCookie,
  delCookie,
  uploadUrl,
  exportUrl,
  getSocket,
  cascaderChange,
}



// WEBPACK FOOTER //
// ./src/utils/util.js